var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PermissionsErrorLayout',[_c('div',{attrs:{"slot":"permissions-error-item"},slot:"permissions-error-item"},[_c('PermissionsErrorItem')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }